import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  ConfirmationAlertCallbackInput,
  ConfirmationAlertDialog,
  ConfirmationAlertUniqueProps,
} from '../confirmation-alert-dialog';

const { useDialogForContext, useDialog: useConfirmationAlertDialog } =
  getDialogHooks<ConfirmationAlertUniqueProps, ConfirmationAlertCallbackInput>(
    ConfirmationAlertDialog
  );
export const useConfirmationAlertDialogForContext = useDialogForContext;
export default useConfirmationAlertDialog;
